import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  Project,
  TenantRole,
  PrimaryKeyId,
  ProjectPrimaryKeyId,
  GuidId,
  IProjectType,
} from '../models';
import { ApiService } from './api/index';
import { HashService } from './hash.service';

/** Project management service */
@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  /** @ignore */
  constructor(private api: ApiService, private hash: HashService) {}

  createBlankProject(projectId: ProjectPrimaryKeyId): Project.Project {
    return {
      id: projectId,
      projectGuid: '' as GuidId,
      type: 0,
      name: '',
      reference: '',
      client: '',
      address: '',
      city: '',
      postcode: '',
      state: '',
      country: '',
      created: '',
      lastModified: 0,
      role: TenantRole.owner,
      photo: { url: '', photoId: -1 as PrimaryKeyId },
      clientEnabled: false,
    };
  }

  /**
   * Get Project Page data
   * @param projectId projectId or cloudId
   * @param cloudproject whether to search device for project
   * @returns
   */
  getProject(projectId: ProjectPrimaryKeyId): Observable<{
    project: Project.Project;
    lists: Project.ListView[];
    contractors: Project.Contractor[];
    company: string;
    projectImage: string;
  }> {
    // console.log("getProjectPageData");

    let project: Project.Project = this.createBlankProject(projectId),
      lists: Project.ListView[] = [],
      contractors: Project.Contractor[] = [],
      projectImage = '',
      company = '';

    return this.api.client.getProject(project.id).pipe(
      map((cloudProject) => {
        if (cloudProject.success) {
          const cloudResult = cloudProject.data;

          company = cloudResult.project.company;
          projectImage = cloudResult.project.photo.url;

          project = {
            ...project,
            id: cloudResult.project.projectId,
            projectGuid: cloudResult.project.projectGuid,
            name: cloudResult.project.name,
            type: cloudResult.project.type as IProjectType,
          };

          lists = cloudResult.lists.map((cs) => {
            return {
              cloudId: cs.id,
              hashId: this.hash.encode(cs.id),
              unit: cs.description || '',
              address: cs.address || '',
              floor: cs.floor || '',
              defectsCount: cs.defectsCount,
              newCount: cs.newCount,
              inProgressCount: cs.inProgressCount,
              completeCount: cs.completeCount,
              overdueCount: cs.overdueCount,
              lastModified: cs.lastModified,
              lastModifiedDefect: cs.lastModifiedDefect,
              isSynced: 0,
            };
          });

          return {
            project: project,
            lists,
            contractors,
            company,
            projectImage,
          };
        }

        throw new Error(cloudProject.message);
      })
    );
  }
}
